module.exports = __webpack_public_path__ + "media/img/before_buy_image_3-69eb12b3.png";